import { RouteRecordRaw } from 'vue-router';
import { ModelType } from '@llws/platform-shared-types/types/db/auth';
import { IRouteConfigAuthMeta } from '@/shared';

/*
  IFRAME ROUTES
  ------------------------------------------------------------------------------
  Standalone pages exclusive to iframe view, only for BSTK. These routes:
    - Use `hideBlade: true` so App.vue skips the global sidebar/topbar.
    - Live under `/iframe/**` so they're easy to identify + gate.

  These are still authenticated Rentsync views; the parent iframe is expected
  to have handled SSO before navigating here.
  ------------------------------------------------------------------------------
*/

const propertyMarketing: RouteRecordRaw = {
  path: '/iframe/properties/:propertyId/marketing',
  name: 'IFramePropertyMarketing',
  component: () => import('@/views/iframe/PropertyMarketing.vue'),
  meta: {
    auth: {
      required: true,
      permissions: [{
        key: 'buildings',
        keyType: ModelType.building,
        idParam: 'propertyId',
        accessType: 'update',
      }],
    } as IRouteConfigAuthMeta,
    title: 'Manage Building for Marketing',
    active: false,
    hideBlade: true,
  },
};

// Route-level access is gated on the `units` product, scoped by :propertyId — permission
// grants for units are keyed by building id (ModelType.building), not unit id, so the
// route carries both params even though only :unitId identifies the record being edited.
const unitMarketing: RouteRecordRaw = {
  path: '/iframe/properties/:propertyId/units/:unitId/marketing',
  name: 'IFrameUnitMarketing',
  component: () => import('@/views/iframe/UnitMarketing.vue'),
  meta: {
    auth: {
      required: true,
      permissions: [{
        key: 'units',
        keyType: ModelType.building,
        idParam: 'propertyId',
        accessType: 'update',
      }],
    } as IRouteConfigAuthMeta,
    title: 'Manage Unit for Marketing',
    active: false,
    hideBlade: true,
  },
};

export default [
  propertyMarketing,
  unitMarketing,
] as RouteRecordRaw[];
